import React, { Component } from "react";
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";
import * as actionCreators from "../../../modules/actions/index";
import * as url from "../../../utils/url";
import {
  analyticsCategories,
  initialChartDetailsState,
} from "../../../utils/categories";
import {
  createChartStep,
  analyticsSteps,
  diversityCategories,
  returnHierarchyGroup,
  diversityFocusOptions,
  kpiBasedType,
} from "../../../utils/constants";
import {
  getAgreegateKpisData,
  filterRawBenchmarkData,
  getGenderLists,
  createKPIAgreegateRequestData,
  getFormattedMappingData,
} from "../../../utils/filterKpisData";
import { addChartDetails } from "../../../utils/createRequestData";
import axios from "../../../axios";
import { connect } from "react-redux";
import Steps from "../../../components/Steps/Steps";
import ChartPrivacy from "../Components/ChartPrivacy/ChartPrivacy";
import ChartPreview from "../Components/ChartPreview/ChartPreview";

import ChartDetails from "../Components/ChartDetails/ChartDetails";
import Benchmark from "../Components/Benchmark/Benchmark";
import ErrorMessage from "../../../components/Message/ErrorMessage/ErrorMessage";
import Loading from "../../../hoc/Loading/Loading";
import sortBy from "lodash/sortBy";
import "../Chart.css";
import find from "lodash/find";
import { isEmpty } from "lodash";

class CreateChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kpiAgrregateData: [],
      benchmark: [],
      kpiList: [],
      ageRange: { start: 0, end: 0 },
      allOfficeKeys: [],
      disabilityArray: [],
      veteranArray: [],
      religionArray: [],
      sexualOrientationArray: [],
      ethnicityArray: [],
      yAxisFormat: "",
      previewOrContinue: false,
      orgMapping: {
        gender: {},
        religionOptions: [],
        veteranOptions: [],
        disabilityOptions: [],
        sexualOrientationOptions: [],
        ethnicityOptions: [],
        occupationOptions: [],
        seniorityOptions: [],
        performanceOptions: [],
        separationOptions: [],
      },
      error: false,
      errorMessage: "",
      industriesList: [],

      chartCategory:
        this.props.match.params && this.props.match.params.category
          ? this.props.match.params.category
          : this.props.location && this.props.location.length > 0
          ? this.props.location.pathname.split("/")[3]
          : "all",

      isChartEdit:
        this.props.location.pathname.indexOf("edit") > -1 ? true : false,
      copyChart:
        this.props.history &&
        this.props.history.location &&
        this.props.history.location.state &&
        this.props.history.location.state.copyChart !== null
          ? this.props.history.location.state.copyChart
          : {},
      KPIerror: false,
      emptyStateImage: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    let { chartDetails } = this.props;
    let nextChart = nextProps.chartDetails;

    if (chartDetails.nextStep !== nextProps.nextStep) {
      return true;
    } else if (this.previewOrContinue) {
      return true;
    } else {
      return false;
    }
  }

  navigateBack = (url) => {
    console.log("navigateBACK --------");
    this.props.onLeaveCreateChart();
    // localStorage.removeItem('chartNavigationFlow');
    return true;
  };

  componentWillMount() {
    let copyChart;
    console.log("will MOUNT",this.props.history );
    if (
      this.props.history == null ||
      this.props.history.location == null ||
      this.props.history.location.state == null ||
      this.props.history.location.state.copyChart == null
    ) {

      console.log("first",this.props.chartDetails)

      copyChart = this.props.chartDetails;
      this.props.onChartDetailsCompleted({ ...copyChart });
    } else {
      console.log("sec")
      copyChart = { ...this.props.history.location.state.copyChart };
      this.props.onChartDetailsCompleted({ ...copyChart });
    }

    // this.props.onChartDetailsCompleted({ ...copyChart });
    let { profile } = this.props.user;
    const location = this.props.history.location;
    if (
      this.props.user &&
      this.props.user.profile &&
      !this.props.chartDetails.category &&
      !this.props.location.state &&
      this.props.user.profile.role !== "Admin"
    ) {
      this.props.history.goBack();
    }

    // if(profile==null || !profile || profile==undefined) {
    //   this.props.history.go(-2);
    // }
    const category = this.props.match.params.category;
  }

  // Get category if coming from analytics category page.
  componentDidMount() {
    console.log("MOUNT");

    // returnHierarchyGroup(this.props.user.organizationId.staticHierarchy)
    let category;
    let { location, chartDetails, categoryKpiData, copyChart } = this.props;
    let stateRetrievedCategory = location.state ? location.state.category : "";
    for (let analyticsCategory of analyticsCategories) {
      if (
        analyticsCategory.name === chartDetails.category ||
        analyticsCategory.name === stateRetrievedCategory
      ) {
        category = analyticsCategory.name;
        break;
      }
    }

    if (chartDetails.category && chartDetails.category !== "") {
      this.getKpiListForCategory(chartDetails.category);
      // this.getAllIndustries();
      // copyChart = copyChart==null?this.props.chartDetails:copyChart
      // Object.keys(this.props.chartDetails).length>0?this.props.chartDetails:copyChart
      if (copyChart != null && copyChart.isCopied) {
        this.props.onChartDetailsCompleted({ ...copyChart });
      }
      // this.getCategories()
    } else {
      if (this.props.location.state && this.props.location.state.category) {
        let chartDetails = { ...this.props.location.state };

        category =
          this.state.copyChart && this.state.copyChart.category
            ? this.state.copyChart.category
            : category;
        chartDetails.nextStep = createChartStep.details;
        // chartDetails.nextStep = createChartStep.benchmark;
        copyChart = { ...this.props.location.state.copyChart };

        this.props.onChooseCategory({
          ...initialChartDetailsState,
          ...chartDetails,
        });
        if (copyChart != null && copyChart.isCopied) {
          this.props.onChartDetailsCompleted({ ...copyChart });
        }
        this.getKpiListForCategory(category);
        // this.getAllIndustries();
        // this.getCategories()
      }
    }

    const category_url =
      find(analyticsCategories, { link: category }) ||
      find(analyticsCategories, { name: category });

    const unlisten = this.props.history.listen((location, action) => {
      if (location.pathname !== `/home/analytics/${category}/create`) {
        unlisten();
      }
    });

    const unblock = this.props.history.block((location, action) => {
      if (location.state != 1) {
        let res = false;
        if (action === "POP" && location.pathname.indexOf(`edit`) > -1) {
          if (
            window.confirm(
              "You have not completed the process yet. Are you sure you want to leave without completing it?"
            )
          ) {
            let res = this.navigateBack(category_url.link);
            if (res) {
              unblock();
              this.props.history.push(`/home/analytics/${category_url.link}`);
              return true;
            }
          }
        }

        if (
          action === "PUSH" &&
          !location.pathname.startsWith(`/home/analytics/${category}/create`)
        ) {
          if (
            window.confirm(
              "You have not completed the process yet. Are you sure you want to leave without completing it?"
            )
          ) {
            let res = this.navigateBack(category_url.link);
            if (res) {
              unblock();
              this.props.history.push(`/home/analytics/${category_url.link}`);
              return true;
            }
          }
        }
        return res;
      } else {
        return unblock();
      }
    });
  }

  getAllIndustries = () => {
    axios.get(url.getMasterListByCategory("INDUSTRY")).then(({ data }) => {
      this.setState({
        industriesList: sortBy(data.data[0].docs, "name"),
      });
    });
  };

  // Handle chart details step completed
  handleChartDetailsCompleted = (details) => {
    let rec = details.kpiRecords;
    this.setState({ error: false, errorMessage: "" });
    if (rec.length > 1) {
      for (var x = 0; x < rec.length; x++) {
        if (JSON.stringify(rec[x]) === JSON.stringify(rec[x + 1])) {
          window.scrollTo(0, 0);
          this.setState({
            error: true,
            errorMessage:
              "Please make sure that the KPIs you select are unique",
          });
          return;
        }
      }
    }

    let { kpiRecords } = details;

    let nextStep = createChartStep.privacy;
    let { orgMapping } = this.state;
    let selectedKpis = kpiRecords.filter((kpi) => kpi.selected);
    if (
      (selectedKpis && selectedKpis.length > 1) ||
      details.kpiType === kpiBasedType.surveyBased
    ) {
      nextStep = createChartStep.privacy;
    }
    selectedKpis = selectedKpis.map((kpiRecord) => {
      if (details.kpiType === kpiBasedType.empDataBased) {
        let kpiRecordDetails = createKPIAgreegateRequestData(
          kpiRecord,
          orgMapping
        );
        return { ...kpiRecordDetails };
      } else if (details.kpiType === kpiBasedType.surveyBased) {
        return {
          code: kpiRecord.selectedKPI.code,
          diversityType: "FEMALE",
        };
      }
    });

    this.getKpiAggregate(
      { ...details, selectedKPIRecords: selectedKpis },
      true,
      { nextStep: nextStep, ...details }
    );
  };

  handleBenchmarkCompleted = (benchmark) => {
    this.props.onChartDetailsCompleted({
      nextStep: createChartStep.privacy,
      ...benchmark,
    });
  };

  handleChartPrivacySettingsCompleted = (privacy) => {
    this.props.onChartPrivacySettingsCompleted({
      nextStep: createChartStep.privacy,
      ...privacy,
    });
    let hierarchyVersion =
      this.props.user.organizationId.hierarchyVersion !== null
        ? this.props.user.organizationId.hierarchyVersion
        : 1;
    // let {allOfficeKeys}=this.state
    this.handleCreateChart({
      ...this.props.chartDetails,
      ...privacy,
      hierarchyVersion,
    });
  };

  // Get kpi list for category
  getKpiListForCategory = (category) => {
    axios
      .get(url.getCategoryKpiList + category)
      .then((response) => {
        if (response && response.data.meta.success) {
          let kpiList = response.data.data;

          kpiList = kpiList.map((kpi) => {
            return {
              id: kpi._id,
              pos: kpi.pos,
              name: kpi.name,
              code: kpi.code,
              description: kpi.description,
              definition: kpi.definition,
              refObject:kpi
            };
          });
          this.setState({ kpiList: kpiList });
          this.getOrganizationMapping();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Get kpi list for category
  getOrganizationMapping = () => {
    let kpiList = this.state.kpiList;
    axios
      .get(url.getExistingMappings(this.props.user.organizationId._id))
      .then((response) => {
        if (response && response.data.meta.success) {
          let {
            gender,
            disability,
            birthDate,
            veteran,
            religion,
            sexualOrientation,
            occupation,
            ethnicity,
            seniority,
            performance,
            separation,
          } = getFormattedMappingData(response.data.data.mapping);

          this.setState({
            kpiList,
            disabilityArray: response.data.data.mapping.disability.data.map(
              (e) => e.reference.name
            ),
            veteranArray: response.data.data.mapping.veteran.data.map(
              (e) => e.reference.name
            ),
            religionArray: response.data.data.mapping.religion.data.map(
              (e) => e.reference.name
            ),
            sexualOrientationArray: response.data.data.mapping.sexualOrientation.data.map(
              (e) => e.reference.name
            ),
            ethnicityArray: response.data.data.mapping.ethnicity.data.map(
              (e) => e.reference.name
            ),
            orgMapping: {
              gender,
              sexualOrientationOptions: sexualOrientation,
              disabilityOptions: disability,
              veteranOptions: veteran,
              religionOptions: religion,
              ethnicityOptions: ethnicity,
              occupationOptions: occupation,
              seniorityOptions: seniority,
              performanceOptions: performance,
              separationOptions: separation,
            },
          });

          this.getCategories();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCategories = () => {
    let {
      sexualOrientationOptions,
      disabilityOptions,
      veteranOptions,
      religionOptions,
      ethnicityOptions,
    } = this.state.orgMapping;
    let {
      disabilityArray,
      veteranArray,
      religionArray,
      sexualOrientationArray,
      ethnicityArray,
    } = this.state;

    axios
      .get(url.categoriesList)
      .then((response) => {
        let resp = response.data.data;
        resp.map((e) => {
          if (e.categoryGrouping === "VETERAN") {
            if (veteranArray.indexOf(e.name) === -1) {
              veteranOptions.push({
                id: e._id,
                name: e.name,
                values: [],
                disabled: true,
                refObject:e
              });
            }
          } else if (e.categoryGrouping === "SEXUAL ORIENTATION") {
            if (sexualOrientationArray.indexOf(e.name) === -1) {
              sexualOrientationOptions.push({
                id: e._id,
                name: e.name,
                values: [],
                disabled: true,
                refObject:e
              });
            }
          } else if (e.categoryGrouping === "DISABILITY") {
            if (disabilityArray.indexOf(e.name) === -1) {
              disabilityOptions.push({
                id: e._id,
                name: e.name,
                values: [],
                disabled: true,
                refObject:e
              });
            }
          } else if (e.categoryGrouping === "RELIGION") {
            if (religionArray.indexOf(e.name) === -1) {
              religionOptions.push({
                id: e._id,
                name: e.name,
                values: [],
                disabled: true,
                refObject:e
              });
            }
          } else if (e.categoryGrouping === "ETHNICITY") {
            if (ethnicityArray.indexOf(e.name) === -1) {
              ethnicityOptions.push({
                id: e._id,
                name: e.name,
                values: [],
                disabled: true,
                refObject:e
              });
            }
          }
        });
        this.setState((prevState) => ({
          orgMapping: {
            ...prevState.orgMapping,
            sexualOrientationOptions,
            disabilityOptions,
            veteranOptions,
            religionOptions,
            ethnicityOptions,
          },
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Get kpi list for category
  getKpiAggregate = async (kpiData, onContinue, details) => {
    let { orgMapping } = this.state;

    let hierarchy = this.props.user.organizationId.staticHierarchy;

    // this should be in redux/the store, and retrieved with user sign in
    let { selectedOffice } = kpiData;
    let { yAxisFormat } = details;

    let allOfficeKeys = returnHierarchyGroup(hierarchy, selectedOffice.value);

    let { maleList, femaleList, otherList, pntsList, nBnList } = getGenderLists(
      orgMapping
    );

    let payload = {
      kpiList: kpiData.selectedKPIRecords,
      kpiType: kpiData.kpiType,
      startDate: kpiData.startDate,
      endDate: kpiData.endDate,
      yAxisFormat,
      allOfficeKeys,
      officeKey: selectedOffice.value,
      useLatestDataAvailable: kpiData.useLatestDataAvailable,
      maleList,
      femaleList,
      otherList,
      pntsList,
      nBnList,
      orgMapping,
      chartId:this.props.chartDetails._id,
      lockedDate:this.props.chartDetails.lockedDate
    };
    let rec = kpiData.selectedKPIRecords;
    this.setState({
      error: false,
      errorMessage: "",
      allOfficeKeys,
      yAxisFormat,
    });

    axios
      .post(url.getkpiAggregate, payload)
      .then(async (response) => {
        // console.log('response.data:  ',  response.data.data)

        // if(this.isChartLocked(this.props.chartDetails)){
        //   this.props.onChartDetailsCompleted({...details})
        //   return
        // }

        if (response && response.data.meta.success) {
          let kpiAgreegateData = [];
          let kpiBenchmarkData = [];
          if (payload.kpiType === kpiBasedType.empDataBased) {
            kpiAgreegateData = response.data.data.kpi;
            kpiBenchmarkData = response.data.data.benchmark;
          } else if (payload.kpiType === kpiBasedType.surveyBased) {
            kpiAgreegateData = response.data.data;
          }
          let {
            kpiRecords,
            kpiType,
            startDate,
            endDate,
            useLatestDataAvailable,
          } = details;
          let formattedKpiData = getAgreegateKpisData({
            kpiRecords,
            kpiAgreegateData,
            kpiType,
            startDate,
            endDate,
            useLatestDataAvailable,
          });
          kpiBenchmarkData = filterRawBenchmarkData(
            response.data.data.benchmark
          );

          let kpiFilterdData = formattedKpiData.filter(
            (kpiData) => kpiData.score
          );
          // if(kpiType == kpiBasedType.empDataBased){
          let isEmptyIndex = await kpiAgreegateData
            .map((el, idx) => {
              if (kpiType == kpiBasedType.empDataBased) {
                let value = Object.values(el)[0];
                if (value.length == 0) {
                  return idx + 1;
                }
              }
            })
            .filter((e) => e != null);

          if (isEmptyIndex && isEmptyIndex.length > 0) {
            this.setState({
              previewOrContinue: true,
              errorMessage: `Note - the following KPIs have no data for the parameters and/or dates selected: ${isEmptyIndex.join(
                ","
              )}. They will not appear on the chart.`,
            });
          }

          if (onContinue) {
            if (payload.kpiList.length === 1) {
              if (
                kpiType === kpiBasedType.empDataBased &&
                kpiFilterdData.length !== 0
              ) {
                kpiBenchmarkData = filterRawBenchmarkData(
                  response.data.data.benchmark
                );
                this.updatekpiAgreegateDataInStore({
                  kpiData,
                  kpiAgreegateData: response.data.data,
                  kpiBenchmarkData,
                  previewOrContinue: true,
                });
                this.props.onChartDetailsCompleted({
                  ...details,
                  allOfficeKeys,
                  kpiData: kpiFilterdData,
                  kpiBenchmarkData,
                  previewOrContinue: true,
                });
                this.setState({ error: false, previewOrContinue: true });
              } else if (
                kpiType === kpiBasedType.surveyBased &&
                kpiFilterdData.length === 0
              ) {
                window.scrollTo(0, 0);
                this.updatekpiAgreegateDataInStore({
                  previewOrContinue: true,
                  emptyStateImage: true,
                  kpiData,
                  kpiAgreegateData: response.data.data,
                  kpiBenchmarkData: kpiBenchmarkData,
                });
                this.setState({
                  previewOrContinue: true,
                  emptyStateImage: true,
                  error: true,
                  errorMessage:
                    "To continue, please select KPIs and/or dates for which there is data available.",
                });
                window.scrollTo(0, 0);
                return;
              } else if (
                kpiType === kpiBasedType.empDataBased &&
                kpiFilterdData.length === 0
              ) {
                window.scrollTo(0, 0);
                this.updatekpiAgreegateDataInStore({
                  previewOrContinue: true,
                  emptyStateImage: true,
                  kpiData,
                  kpiAgreegateData: response.data.data,
                  kpiBenchmarkData: kpiBenchmarkData,
                });
                this.setState({
                  previewOrContinue: true,
                  emptyStateImage: true,
                  error: true,
                  errorMessage:
                    "To continue, please select KPIs and/or dates for which there is data available.",
                });
                window.scrollTo(0, 0);
                return;
              } else if (
                kpiType === kpiBasedType.surveyBased &&
                kpiFilterdData.length > 0
              ) {
                this.updatekpiAgreegateDataInStore({
                  previewOrContinue: true,
                  kpiData,
                  kpiAgreegateData: response.data.data,
                  kpiBenchmarkData: kpiBenchmarkData,
                });
                this.props.onChartDetailsCompleted({
                  ...details,
                  kpiData: kpiFilterdData,
                  allOfficeKeys,
                });
                this.setState({ error: false, previewOrContinue: true });
              }

              // CHECK HERE
            } else if (
              payload.kpiList.length > 1 &&
              kpiFilterdData.length === 0
            ) {
              this.updatekpiAgreegateDataInStore({
                previewOrContinue: true,
                emptyStateImage: true,
                kpiData,
                kpiAgreegateData: response.data.data,
                kpiBenchmarkData: kpiBenchmarkData,
              });
              window.scrollTo(0, 0);
              this.setState({
                previewOrContinue: true,
                emptyStateImage: true,
                error: true,
                errorMessage:
                  "To continue, please select KPIs and/or dates for which there is data available.",
              });
              return;
            } else {
              this.updatekpiAgreegateDataInStore({
                previewOrContinue: true,
                kpiData,
                kpiAgreegateData: response.data.data,
                kpiBenchmarkData: kpiBenchmarkData,
              });
              this.props.onChartDetailsCompleted({
                ...details,
                kpiData: kpiFilterdData,
                allOfficeKeys,
              });
              this.setState({ error: false, previewOrContinue: true });
            }
          } else {
            this.setState({ previewOrContinue: true });
            this.updatekpiAgreegateDataInStore({
              previewOrContinue: true,
              kpiData,
              kpiAgreegateData: response.data.data,
              kpiBenchmarkData,
            });
          }
        }
      })
      .catch((error) => {
        window.scrollTo(0, 0);
        this.setState({
          error: true,
          errorMessage:
            "To continue, please select KPIs and/or dates for which there is data available.",
          emptyStateImage: true,
          previewOrContinue: true,
        });
        this.props.saveAgreegateData({
          previewOrContinue: true,
          emptyStateImage: true,
          kpiAgreegateData: [],
          kpiBenchmarkData: [],
          kpiData: [],
        });
      });
  };

  updatekpiAgreegateDataInStore = ({
    kpiData,
    kpiAgreegateData,
    kpiBenchmarkData,
  }) => {
    let { kpi } = kpiAgreegateData;

    if (kpi !== undefined && kpi !== null) {
      let arrayCheck = true;
      if (kpi.length === 1 && Object.values(kpi[0])[0].length == 0) {
        arrayCheck = false;
      }
      if (arrayCheck !== true) {
        window.scrollTo(0, 0);
        this.props.saveAgreegateData({
          kpiData,
          kpiAgreegateData: kpiAgreegateData.kpi,
          kpiBenchmarkData,
        });
        this.setState({
          previewOrContinue: true,
          emptyStateImage: true,
          error: true,
          errorMessage:
            "To continue, please select KPIs and/or dates for which there is data available.",
        });
        return;
      }
    }

    let dataBool = true;
    if (kpiAgreegateData) {
      if (kpiData.kpiType === "SURVEY_BASED") {
        kpiAgreegateData.map((e) => {
          let v = Object.values(e)[0].length;

          if (v > 0) {
            return (dataBool = false);
          }
        });
        this.setState({
          previewOrContinue: dataBool,
          emptyStateImage: dataBool,
        });
      } else {
        kpi.map((e) => {
          let v = Object.values(e)[0].length;

          if (v > 0) {
            return (dataBool = false);
          }
        });
        this.setState({
          previewOrContinue: dataBool,
          emptyStateImage: dataBool,
        });
      }
    }

    if (kpiData.kpiType === kpiBasedType.empDataBased) {
      this.props.saveAgreegateData({
        kpiData,
        kpiAgreegateData: kpiAgreegateData.kpi,
        kpiBenchmarkData,
      });
    } else if (kpiData.kpiType === kpiBasedType.surveyBased) {
      this.props.saveAgreegateData({ kpiAgreegateData, kpiBenchmarkData: [] });
    }
  };

  // Make create chart request if chart data validated.
  handleCreateChart = (chartDetails) => {
    let { isChartEdit, chartCategory } = this.state;
    let {
      name,
      category,
      selectedOffice,
      hierarchyVersion,
      allOfficeKeys,
      kpiType,
      invitedUsers,
      yAxisFormat,
      privacy,
      permission,
      genderType,
      kpiAgreegateData,
      kpiRecords,
      selectedBenchmarkData,
      benchmarkLocation,
      startDate,
      endDate,
      useLatestDataAvailable,
      lockedDate
    } = chartDetails;
    selectedOffice = {
      label: selectedOffice.label,
      value: selectedOffice.value,
    };
    let createChartData = {
      name,
      category,
      useLatestDataAvailable,
      privacy,
      kpiType,
      selectedOffice,
      yAxisFormat,
      hierarchyVersion,
      allOfficeKeys,
      invitedUsers,
      lockedDate
    };
    createChartData = addChartDetails(
      {
        kpiAgreegateData,
        kpiRecords,
        genderType,
        selectedBenchmarkData,
        benchmarkLocation,
        startDate,
        endDate,
        permission,
        kpiType,
        useLatestDataAvailable,
      },
      createChartData
    );

    console.log("createChartData",createChartData)
    let that = this;
    if (isChartEdit) {
      axios
        .put(url.editChart(this.props.chartDetails._id), { ...createChartData })
        .then((response) => {
          // localStorage.removeItem('chartNavigationFlow');

          // that.props.history.replace(`/home/analytics/${chartCategory}`);
          let url = `/home/analytics/${chartCategory}`;
          //  this.props.history.push({pathname : 'success',state : {type : 'positions'}});
          that.props.onCreateChartSuccess();
          that.props.history.push({ pathname: url, state: 1 });
        })
        .catch((error) => {
          this.setState({
            error: true,
            errorMessage: "Failed to create a chart. Please try again.",
          });
          window.scrollTo(0, 0);
        });
    } else {
      axios
        .post(url.createChart, { ...createChartData })
        .then((response) => {
          // localStorage.removeItem('chartNavigationFlow');

          let url = `/home/analytics/${chartCategory}`;
          //  this.props.history.push({pathname : 'success',state : {type : 'positions'}});
          that.props.onCreateChartSuccess();
          that.props.history.push({ pathname: url, state: 1 });
        })
        .catch((error) => {
          this.setState({
            error: true,
            errorMessage: "Failed to create a chart. Please try again.",
          });
          window.scrollTo(0, 0);
        });
    }
  };

  // Handle got to previus page
  handleGoBack = (showEmpty) => {
    let previousStep = createChartStep.details;
    // if (this.props.chartDetails.nextStep === editChartStep.benchmark) {
    //   previousStep = editChartStep.details;
    // } else if (this.props.chartDetails.nextStep === editChartStep.privacy) {
    //   let { kpiRecords } = this.props.chartDetails;
    //   previousStep = editChartStep.benchmark;
    //   let selectedKpis = kpiRecords.filter(kpi=> kpi.selected);
    //   if((selectedKpis && selectedKpis.length > 1) || this.props.chartDetails.kpiType === kpiBasedType.surveyBased) {
    //     previousStep = editChartStep.details;
    //   }
    // }
    if (showEmpty) {
      window.scrollTo(0, 0);
      this.setState({
        error: true,
        errorMessage:
          "To continue, please select KPIs and/or dates for which there is data available.",
        emptyStateImage: true,
        previewOrContinue: true,
      });
    }
    this.setState({ previewOrContinue: false });
    this.props.onGoBackPressed({ nextStep: previousStep });
  };

  navigateToCategory = () => {
    const category = this.props.match.params.category;
    this.props.history.push(`/home/analytics/${category}`);
  };

  handleGetKpiData = (kpiData) => {
    let { orgMapping } = this.state;

    kpiData.selectedKPIRecords = kpiData.selectedKPIRecords.map(
      (kpiRecord_1) => {
        if (kpiData.kpiType === kpiBasedType.empDataBased) {
          let kpiRecordDetails = createKPIAgreegateRequestData(
            kpiRecord_1,
            orgMapping
          );
          return { ...kpiRecordDetails };
        } else if (kpiData.kpiType === kpiBasedType.surveyBased) {
          return {
            code: kpiRecord_1.selectedKPI.code,
            diversityType: "FEMALE",
          };
        }
      }
    );
    this.getKpiAggregate(kpiData, false, {});
  };
  isChartLocked = (chartDetails) => {
    if (chartDetails._id && chartDetails.lockedDate && chartDetails.lockedDate != null) {
      // diabled set to false if the user is the owner
      return true;
    } else {
      // disabled on dropdown set to true if not owner
      return false;
    }
  };

  render() {
    let {
      kpiList,
      chartCategory,
      yAxisFormat,
      orgMapping,
      previewOrContinue,
      error,
      errorMessage,
      industriesList,
      ageRange,
      copyChart,
      allOfficeKeys,
    } = this.state;

    let { chartDetails, user, match } = this.props;
    let isEdit =
      match && match.url && match.url.indexOf("edit") > -1 ? "Edit" : "Create";
    let createChartCurrentStep = null;
    let currentChartStep = 0;

    console.log("orgMapping---", orgMapping);

    if (this.props.chartDetails.nextStep === createChartStep.details) {
      currentChartStep = 1;
      createChartCurrentStep = (
        <ChartDetails
          onCompleted={this.handleChartDetailsCompleted}
          goBackToPreviousStep={this.handleGoBack}
          kpiList={kpiList}
          ageRange={ageRange}
          kpiType={
            copyChart != null
              ? copyChart.kpiType
              : this.props.chartDetails.kpiType
          }
          orgMapping={orgMapping}
          previewOrContinue={this.state.previewOrContinue}
          previewChart={this.handleGetKpiData}
          industriesList={industriesList}
          user={user}
          isChartLocked={this.isChartLocked(this.props.chartDetails)}
          copyChart={!isEmpty(copyChart)  ? copyChart : this.props.chartDetails}
          emptyStateImage={this.state.emptyStateImage}
          updateLockToggle={(data)=>{
            if(!isEmpty(copyChart)){
               this.setState({copyChart:{...this.state.copyChart,lockedDate:data.lockedDate}})
            }else{
                this.props.onChartPrivacySettingsCompleted({...this.props.chartDetails,lockedDate:data.lockedDate})
            }
          }}
          {...this.props}
        />
      );
    } else if (chartDetails.nextStep === createChartStep.privacy) {
      currentChartStep = 2;
      createChartCurrentStep = (
        <div>
          <ChartPrivacy
            onCompleted={this.handleChartPrivacySettingsCompleted}
            goBackToPreviousStep={this.handleGoBack}
            industriesList={industriesList}
            user={user}
            isCopied={
              copyChart && copyChart != null && copyChart.isCopied
                ? copyChart.isCopied
                : false
            }
            allOfficeKeys={allOfficeKeys}
            yAxisFormat={this.yAxisFormat}
            isChartLocked={this.isChartLocked(this.props.chartDetails)}
            {...this.props}
          />
          ;
          <ChartPreview
            chartDetails={chartDetails}
            kpiData={[...chartDetails.kpiData]}
            // benchmarkData={filteredBenchmarkData}
            startDate={chartDetails.startDate}
            endDate={chartDetails.endDate}
            yAxisFormat={yAxisFormat}
            useLatestDataAvailable={chartDetails.useLatestDataAvailable}
            // name={this.state.name.value}
            // privacy={this.state.privacy}
            previewOrContinue={previewOrContinue}
            step={createChartStep.privacy}
            industriesList={industriesList}
            isChartLocked={this.isChartLocked(this.props.chartDetails)}
            user={user}
          />
        </div>
      );
    }
    return (
      <div className="createChartPageContainer">
        <div>
          <Breadcrumb>
            <BreadcrumbItem>
              <a
                className="create-chart-link"
                onClick={this.navigateToCategory}
              >
                {chartDetails.category}
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem active>
              <span className="create-chart-active-category">
                {isEdit} Chart
              </span>
            </BreadcrumbItem>
            {isEdit == "Edit" || (chartDetails && chartDetails.isCopied) ? (
              <BreadcrumbItem active>
                <span className="create-chart-active-category chart-name-01-title">
                  {" "}
                  {chartDetails && chartDetails.name
                    ? chartDetails.name
                    : "Current"}{" "}
                </span>
              </BreadcrumbItem>
            ) : null}
          </Breadcrumb>
        </div>
        <div className="create-new-chart-title mt30">{isEdit} Chart</div>
        <Row>
          <Col sm="11" md="11">
            <Steps steps={analyticsSteps} currentStep={currentChartStep} />
          </Col>
        </Row>
        {error && <ErrorMessage message={errorMessage} />}
        {createChartCurrentStep}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    chartDetails: state.analytics.chartDetails,
    categoryKpiData: state.analytics.categoryKpiData,
    benchmarkOptions: state.analytics.benchmarkOptions,
    user: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChooseCategory: (data) =>
      dispatch(actionCreators.addChartChooseCategorySuccess(data)),
    onCategoryKpiDataRetrived: (data) =>
      dispatch(actionCreators.categoryKpiDataFetched(data)),
    onChartDetailsCompleted: (data) =>
      dispatch(actionCreators.chartDetailsCompleted(data)),
    saveAgreegateData: (data) =>
      dispatch(actionCreators.agreegateDataFetched(data)),
    onChartPrivacySettingsCompleted: (data) =>
      dispatch(actionCreators.chartPrivacySettingsCompleted(data)),
    onGoBackPressed: (data) =>
      dispatch(actionCreators.chartGoBackPressed(data)),
    onCreateChartSuccess: (data) =>
      dispatch(actionCreators.createChartSuccess(data)),
    onLeaveCreateChart: () => dispatch(actionCreators.leaveCreateChart()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(CreateChart, axios));
